import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
	selector: 'app-bag-transport-term-general-rooms-data',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './bag-transport-term-general-rooms-data.component.html',
	styleUrl: './bag-transport-term-general-rooms-data.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BagTransportTermGeneralRoomsDataComponent {
	sumOfConfirmedOffers = input<number>();
	sumOfOptionOffers = input<number>();
	sumOfAllReservations = input<number>();
	maxRooms = input<number>();

	readonly sumOfAllRemainingRooms = computed(
		() => this.maxRooms() - (this.sumOfOptionOffers() + this.sumOfConfirmedOffers()),
	);
}
